import React, { useState, useEffect } from 'react';
import './FreeTrial.css';
import ConsultationSection from '../components/ConsultationSection';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';

const FreeTrial = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    country: '',
    course: '',
    message: '',
    consent: false
  });

  useEffect(() => {
    // Load Google reCAPTCHA v2 API script dynamically
    const scriptId = 'google-recaptcha-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://www.google.com/recaptcha/api.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.consent) {
      Swal.fire({
        title: 'Consent Required',
        text: "Please consent to the terms to proceed.",
        icon: 'warning',
        confirmButtonColor: '#5c9456'
      });
      return;
    }
    try {
      await submitForm('Free Trial Form', formData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${formData.fullName}! Your free trial request has been submitted.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        country: '',
        course: '',
        message: '',
        consent: false
      });
      window.location.href = '/thank-you-enrollment-successful/';
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  const customSubtitle = (
    <div className="consultation-section__custom-subtitle">
      <p>— Get answers to your questions — Enquire about our Holy Quran teaching services</p>
      <p>— Recommendations & suggestions from experts</p>
    </div>
  );

  return (
    <div className="free-trial-page" id="free-trial-page">
      {/* Premium Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Free Trial</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">Home</a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Free Trial</span>
          </nav>
        </div>
      </section>



      {/* Signup Section */}
      <section className="signup-trial-section">
        <div className="signup-trial-container">
          <h2 className="signup-trial-heading">
            SIGNUP FOR 3 DAYS FREE TRIAL ONLINE QURAN CLASSES.
          </h2>

          <div className="signup-trial-card">
            {/* Left Side: Form */}
            <div className="signup-trial-form-col">
              <p className="signup-trial-subheading">
                No credit card required. No payment required for Free trial. Start today!
              </p>

              <form onSubmit={handleSubmit} className="signup-trial-form">
                <div className="signup-trial-form-row">
                  <div className="signup-trial-field">
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                      className="signup-trial-input"
                    />
                  </div>
                  <div className="signup-trial-field">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="signup-trial-input"
                    />
                  </div>
                  <div className="signup-trial-field">
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+1 Mobile Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="signup-trial-input"
                    />
                  </div>
                </div>

                <div className="signup-trial-form-row">
                  <div className="signup-trial-field">
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      required
                      className="signup-trial-select"
                    >
                      <option value="">Country</option>
                      <option value="USA">USA</option>
                      <option value="Canada">Canada</option>
                      <option value="UK">UK</option>
                      <option value="Australia">Australia</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="signup-trial-field">
                    <select
                      name="course"
                      value={formData.course}
                      onChange={handleChange}
                      required
                      className="signup-trial-select"
                    >
                      <option value="">Course</option>
                      <option value="Noorani Qaida">Noorani Qaida</option>
                      <option value="Quran with Tajweed">Quran with Tajweed</option>
                      <option value="Quran Memorization">Quran Memorization</option>
                      <option value="Quran Translation">Quran Translation</option>
                      <option value="Arabic Grammar">Arabic Grammar</option>
                    </select>
                  </div>
                </div>

                <div className="signup-trial-field signup-trial-field--full">
                  <textarea
                    name="message"
                    placeholder="Anything you would like to ask?"
                    value={formData.message}
                    onChange={handleChange}
                    className="signup-trial-textarea"
                  />
                </div>

                <div className="signup-trial-consent">
                  <label className="signup-trial-consent-label">
                    <input
                      type="checkbox"
                      name="consent"
                      checked={formData.consent}
                      onChange={handleChange}
                      required
                      className="signup-trial-checkbox"
                    />
                    <span>
                      By providing a telephone number and submitting this form you are consenting to be contacted by SMS text message. Message &amp; data rates may apply. Message frequency may vary. You can reply STOP to opt-out of further messaging and HELP for more information. (<a href="https://alquranlesson.com/privacy-policy/" target="_blank" rel="noopener noreferrer">https://alquranlesson.com/privacy-policy/</a>).
                    </span>
                  </label>
                </div>

                {/* reCAPTCHA container */}
                <div className="signup-trial-recaptcha-wrapper">
                  <div
                    className="g-recaptcha"
                    data-sitekey={
                      window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
                        ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' // Public Google test key for localhost development
                        : '6LdiHz4tAAAAAONg4UJVDRkG1K3enavhCUQbnmLx' // Production key for alquranlesson.com
                    }
                  ></div>
                </div>

                <button type="submit" className="signup-trial-submit-btn">
                  SIGN UP
                </button>
              </form>
            </div>

            {/* Right Side: Info Panel */}
            <div className="signup-trial-info-col">
              <h3 className="signup-trial-info-title">
                Signup For 3 Days Free Trial lessons
              </h3>
              <ul className="signup-trial-info-list">
                <li className="signup-trial-info-item">
                  Your information is 100% secure and received by manager only!
                </li>
                <li className="signup-trial-info-item">
                  We do not sell, Rent or share your information.
                </li>
                <li className="signup-trial-info-item">
                  We follow strict data protection policy.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Worried Section */}
      <section className="worried-section">
        <div className="worried-container">
          <h2 className="worried-heading">
            Worried about Quranic education of your kids or yourself?
          </h2>

          <div className="worried-grid">
            {/* Column 1 */}
            <div className="worried-col worried-col--white">
              <div className="worried-img-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/one-to-one.webp`}
                  alt="One-On-One Classes"
                  className="worried-img"
                />
              </div>
              <h3 className="worried-col-title">One-On-One Classes</h3>
              <p className="worried-col-desc">
                Our classes comprise of one on one live tutoring between teacher and student. This allows student's to progress at their own pace
              </p>
            </div>

            {/* Column 2 */}
            <div className="worried-col worried-col--light-gray">
              <div className="worried-img-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/watch.webp`}
                  alt="Flexible timings"
                  className="worried-img"
                />
              </div>
              <h3 className="worried-col-title">Flexible timings</h3>
              <p className="worried-col-desc">
                Over 150 in house tutors offers flexibility to students in terms of availability
              </p>
            </div>

            {/* Column 3 */}
            <div className="worried-col worried-col--gray">
              <div className="worried-img-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/tutor.webp`}
                  alt="More than just a Tutor"
                  className="worried-img"
                />
              </div>
              <h3 className="worried-col-title">More than just a Tutor</h3>
              <p className="worried-col-desc">
                Our Quran sessions teach students more than just Quran recitation, covering Surahs, Salah, &amp; more
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pioneers Section */}
      <section className="pioneers-section">
        <div className="pioneers-container">
          <div className="pioneers-content-col">
            <h4 className="pioneers-heading">
              PIONEERS OF ONLINE QURAN LEARNING
            </h4>
            <p className="pioneers-desc">
              Over the years, Al Quran Lesson has established itself as the number one choice among parents who wish to teach their children the Holy Quran. Al Quran Lesson takes special measures to ensure the Quran learning process is easy and effective, so that after every lesson the student of our online Quran Tutoring classes leaves with better knowledge of Quran.
            </p>
            <a
              href="#free-trial-page"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('free-trial-page')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="pioneers-btn"
            >
              BOOK FREE TRIAL TODAY
            </a>
          </div>
          <div className="pioneers-image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/trail.webp`}
              alt="Pioneers of Online Quran Learning"
              className="pioneers-img"
            />
          </div>
        </div>
      </section>

      {/* Unlock Section */}
      <section
        className="unlock-section"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/bgimg.avif')`
        }}
      >
        <div className="unlock-overlay"></div>
        <div className="unlock-container">
          <p className="unlock-subheading">HELPING YOU ACHIEVE SUCCESS</p>
          <h5 className="unlock-heading">UNLOCK YOUR FULL POTENTIAL</h5>
          <p className="unlock-desc">
            You and your family can study Arabic and learn the Quran online, from the comfort of your home, on your schedule.
          </p>
          <a
            href="#free-trial-page"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('free-trial-page')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="unlock-btn"
          >
            GET FREE TRIAL NOW
          </a>
        </div>
      </section>

      {/* Consultation Section */}
      <ConsultationSection
        title="FREE CONSULTATION CALL - Ask From Experts"
        subtitle={customSubtitle}
      />
    </div>
  );
};

export default FreeTrial;

